<template>
  <a-col :span="12">
    <a-form-item label="可否搜索">
      <a-radio-group v-model:value="config.show_search">
        <a-radio :value="false">否</a-radio>
        <a-radio :value="true">是</a-radio>
      </a-radio-group>
    </a-form-item>
  </a-col>
</template>

<script setup lang="ts">
/* 可否搜索配置（共享）。 */
defineProps<{ config: any }>();
</script>
